'use client';

import React, { createContext, useContext } from 'react';
import type { Media } from '@backbone-one/contentful-client';

const CustomizationsContext = createContext<Record<string, Media> | undefined>(
  undefined
);

export const useCustomizationContext = () => {
  const context = useContext(CustomizationsContext);
  if (!context) {
    throw new Error(
      'useCustomizations must be used within a CustomizationsProvider'
    );
  }
  if (Object.entries(context).length == 0) {
    throw new Error(
      'CustomizationsProvider must be provided with at least one customization'
    );
  }
  return (key: string) => context[key];
};

export default function CustomizationsProvider({
  customizations,
  children,
}: {
  customizations: Record<string, Media>;
  children: React.ReactNode;
}) {
  return (
    <CustomizationsContext.Provider value={customizations}>
      {children}
    </CustomizationsContext.Provider>
  );
}
